import { routes as orgStructure } from "../orgStructure";
import { routes as employeeRecord } from "../employeeRecord";

export const detailRoutes = {
    ...orgStructure,
    ...employeeRecord,
    "/referrals": {
        title: "Referrals"
    },
};
